import { render } from "./HeroImage.vue?vue&type=template&id=0d9bdd2d&ts=true"
import script from "./HeroImage.vue?vue&type=script&lang=ts"
export * from "./HeroImage.vue?vue&type=script&lang=ts"

import "./HeroImage.vue?vue&type=style&index=0&id=0d9bdd2d&lang=scss&scope=true"

import exportComponent from "C:\\ProjectsLaravel\\nft_imw_v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/ts/frontend/components/HeroImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d9bdd2d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d9bdd2d', __exports__)) {
    console.log('reload')
    api.reload('0d9bdd2d', __exports__)
  }
  
  module.hot.accept("./HeroImage.vue?vue&type=template&id=0d9bdd2d&ts=true", () => {
    console.log('re-render')
    api.rerender('0d9bdd2d', render)
  })

}


export default __exports__